import React, {Component} from 'react';
import {
    api,
    apis,
    db_tables,
    DBHelpers,
    errors,
    isLogin,
    msg,
    rd,
    route,
    routes,
    sendGet,
    type_modal,
    type_modal_icon
} from "../../vars/rd";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {jsi} from "../../index";
import {osname, toObjectFromQuery, toQueryFromObject} from "../../modules/func";
import {modalShow} from "../../libs/redux/actions/modal";


class AuthLogin extends Component {
    msg;
    idRef;
    pwRef;
    mounted = false;
    constructor(props) {
        super(props);
        if(isLogin()) route(routes.main);

        this.handleKeydown = this.keyDown.bind(this);
        this.handleHashChange = this.hashChange.bind(this);

        this.msg = msg();

        this.state = {
            is_saved: true,
            shopid: '',
            shoppw: '',
            auth_code: ''
        }
    }



    get dispatch() {
        return this.props.hasOwnProperty('dispatch') ? this.props.dispatch : () => {};
    }

    async componentDidMount() {
        this.mounted = true;
        if(this.idRef) {
            this.idRef.focus();
            jsi.jsi_enable_input();
        }

        if(jsi && typeof jsi.jsi_set_page_code === "function") {
            jsi.jsi_set_page_code('login');
        }

        window.addEventListener('hashchange', this.handleHashChange);
        document.addEventListener('keydown', this.handleKeydown);

        DBHelpers.openDB()
            .then(async db => {
                const users = await db.select(db_tables.users, (doc) => (!!doc.shopid));
                if(users) {
                    // if(rd.os !== "browser") delete users.mac;
                    if(this.mounted) {
                        this.setState(
                            {...this.state, ...users},
                            async () => {
                                await this.checkLogin();
                            }
                        );
                    }
                }
            })
            .catch(e => errors(e))

        if(this.idRef) {
            this.idRef.addEventListener("focusin", () => {
                jsi.jsi_enable_input();
            });
            this.idRef.addEventListener("focusout", () => {
                jsi.jsi_disable_input();
            });
        }

        if(this.pwRef) {
            this.pwRef.addEventListener("focusin", () => {
                jsi.jsi_enable_input();
            });
            this.pwRef.addEventListener("focusout", () => {
                jsi.jsi_disable_input();
            });
        }
    }

    componentWillUnmount() {
        // if(this.idRef) {
        //     this.idRef.removeEventListener("focusin", jsi.jsi_enable_input);
        //     this.idRef.removeEventListener("focusout", jsi.jsi_disable_input);
        // }
        //
        // if(this.pwRef) {
        //     this.pwRef.removeEventListener("focusin", jsi.jsi_enable_input);
        //     this.pwRef.removeEventListener("focusout", jsi.jsi_disable_input);
        // }

        this.mounted = false;
        this.idRef = null;
        this.pwRef = null;

        window.removeEventListener('hashchange', this.handleHashChange);
        document.removeEventListener('keydown', this.handleKeydown);


    }

    /**
     * 플레이어 로그인 상태 체크
     * @returns {Promise<void>}
     */
    async checkLogin() {
        const id = await jsi.jsi_get_id() || this.state.shopid || '';
        const mac = await jsi.jsi_get_mac() || this.state.mac || '';

        if(id && mac) {
            const args = {
                id,
                mac,
                pw: '',
                auth_code: ''
            };
            const json = await sendGet(api(apis.login, args));
            if(this.mounted) {
                if(json && json.result === "OK") {
                    // 맥 버전이 다른경우 로그아웃 처리
                    if(json.status !== "OK") {
                        this.setState(
                            {mac: ''},
                            async () => {
                                jsi.jsi_logout();
                            }
                        );
                    }
                    else route(routes.login_process + '?' + toQueryFromObject({
                        id: json.id,
                        mac: json.mac,
                        app: osname(),
                        serviceid: json.serviceid,
                        groupid: json.groupid,
                        cpmode: rd.app,
                        ver_player: '',
                        ver_page: '',
                        ver_web: '',
                        ver_os: ''
                    }));
                }
            }
        }
    }

    hashChange() {
        const hash = window.location.hash;
        if(hash) {
            const json = toObjectFromQuery(hash.split('?')[1])
            if(json && json.hasOwnProperty("error")) {
                this.dispatch(
                    modalShow(
                        type_modal.alert,
                        {
                            message: this.msg.login_fail
                        }
                    )
                );
            }
        }
    }

    keyDown(e) {
        if (e.which === 13) this.login();
    }

    login() {
        if(!this.state.shopid) {
            this.dispatch(
                modalShow(
                    type_modal.alert,
                    {
                        icon: type_modal_icon.error,
                        header: this.msg.login,
                        message: this.msg.id_require
                    }
                )
            );
            return;
        }

        if(!this.state.shoppw) {
            this.dispatch(
                modalShow(
                    type_modal.alert,
                    {
                        icon: type_modal_icon.error,
                        header: this.msg.login,
                        message: this.msg.pw_require
                    }
                )
            );
            return;
        }

        jsi.jsi_login(this.state.shopid, this.state.shoppw);
    }

    render() {
        return (
            <div className="login">
                <h2><img src="/images/logo-login.png" alt={rd.name}/></h2>
                <div className="login-wrap">
                    <form id="frmLogin" className="box">
                        <div className="item">
                            <label>아이디</label>
                            <input type={'text'} id={'id'} name={'id'}
                                   placeholder={'아이디'}
                                   ref={el => {this.idRef = el}}
                                   value={this.state.shopid}
                                   autoCapitalize={'none'}
                                   autoCorrect={'off'}
                                   onChange={(e) => this.setState({shopid: e.target.value})}/>
                        </div>
                        {
                            !this.state.mac ?
                                <div className={'item'}>
                                    <label>비밀번호</label>
                                    <input type={'password'} id={'pass'} name={'pass'}
                                           placeholder={'비밀번호'}
                                           ref={el => {this.pwRef = el}}
                                           autoCapitalize={'none'}
                                           autoCorrect={'off'}
                                           value={this.state.shoppw}
                                           onChange={(e) => this.setState({shoppw: e.target.value})}/>
                                </div> :
                                <div className={'item'}>
                                    <label>맥어드레스</label>
                                    <input type={'text'} id={'mac'} name={'mac'}
                                           placeholder={'맥어드레스'} readOnly={true}
                                           autoCapitalize={'none'}
                                           autoCorrect={'off'}
                                           value={this.state.mac || '확인되지 않음'}/>
                                </div>
                        }

                        <div className="btn-wrap">
                            <div className="btn"><span className="btn-l btn-p3" onClick={() => this.login()}>로그인</span></div>
                        </div>
                    </form>

                </div>
                <div className="cust-text">라임덕 고객센터 1566-2864</div>
            </div>
        );
    }
}

export default connect()(withRouter(AuthLogin));


// WEBPACK FOOTER //
// ./src/pages/auth/login.jsx